export default __webpack_public_path__ + "static/ccl-1-8fa6a98d611534416407d340e0573895.png";